<form class="pcard" [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
  <h2><i class="fa-solid fa-lock"></i> Change Password</h2>

  <div class="grid-2">
    <div class="fld span-2">
      <label for="oldPassword">Old Password</label>
      <input type="password" id="oldPassword" formControlName="oldPassword"
             placeholder="Enter your old password" autocomplete="current-password" />
      <div class="err" *ngIf="showErr('oldPassword', 'required')">Old password is required.</div>
    </div>

    <div class="fld">
      <label for="newPassword">New Password</label>
      <input type="password" id="newPassword" formControlName="newPassword"
             placeholder="Enter your new password" autocomplete="new-password" />
      <div class="err" *ngIf="showErr('newPassword', 'required')">New password is required.</div>
      <div class="err" *ngIf="showErr('newPassword', 'minlength')">New password must be at least 6 characters long.</div>
    </div>

    <div class="fld">
      <label for="confirmNewPassword">Confirm New Password</label>
      <input type="password" id="confirmNewPassword" formControlName="confirmNewPassword"
             placeholder="Confirm new password" autocomplete="new-password" />
      <div class="err" *ngIf="showErr('confirmNewPassword', 'required')">Confirm password is required.</div>
      <div class="err" *ngIf="showErr('confirmNewPassword', 'minlength')">Confirm password must be at least 6 characters long.</div>
      <div class="err" *ngIf="mismatch">Confirm password must match the new password.</div>
    </div>
  </div>

  <div class="actions">
    <button type="submit" class="btn-pink" [disabled]="!changePasswordForm.valid || mismatch || saving">
      <i class="fa-solid fa-key"></i> {{ saving ? 'Updating...' : 'Update Password' }}
    </button>
  </div>
</form>

<div class="pcard">
  <h2><i class="fa-solid fa-box-open"></i> Package Subscription</h2>
  <p class="lead">Cancelling stops your subscription from renewing.</p>
  <div class="actions">
    <button type="button" class="btn-ghost danger" (click)="cancelSubscription()">
      <i class="fa-solid fa-ban"></i> Cancel Subscription
    </button>
  </div>
</div>
